import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';

interface AuthenticatedContextInterface {
  isAuthenticated: string | null;
  setIsAuthenticated: (value: string | null) => void;
}

const AuthenticatedContext = createContext({} as AuthenticatedContextInterface);

export const AuthenticatedProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem('sc-logged')
  );
  

  useEffect(() => {
    if (isAuthenticated) {
      localStorage.setItem('sc-logged', new Date().toISOString());
    } else {
      localStorage.removeItem('sc-logged');
    }
  }, [isAuthenticated]);

  return (
    <AuthenticatedContext.Provider
      value={{
        isAuthenticated,
        setIsAuthenticated,
      }}
    >
      {children}
    </AuthenticatedContext.Provider>
  );
};

export function useAuthenticated() {
  const context = useContext(AuthenticatedContext);

  return context;
}
